import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import React from 'react';

import { dateShortcutsByType } from '../../../../functions/const/datesShortCuts';

dayjs.extend(utc);

interface DateShortcutSelectorProps {
  label: string;
  dateType: string;
  selectedShortcut: string;
  onShortcutChange: (
    shortcut: string,
    startDate?: string,
    endDate?: string,
  ) => void;
}

/**
 * Componente selector de atajos de fechas
 * Permite seleccionar rangos predefinidos como "Últimos 7 días", etc.
 */
const DateShortcutSelector: React.FC<DateShortcutSelectorProps> = ({
  label,
  dateType,
  selectedShortcut,
  onShortcutChange,
}) => {
  const shortcuts =
    dateShortcutsByType[dateType as keyof typeof dateShortcutsByType] || [];

  const handleChange = (shortcutLabel: string) => {
    if (shortcutLabel === 'none') {
      onShortcutChange('none');
      return;
    }

    const shortcut = shortcuts.find((sc) => sc.label === shortcutLabel);
    if (shortcut) {
      const startDate = dayjs(shortcut.startDate)
        .startOf('day')
        .utc()
        .format('YYYY-MM-DD');
      const endDate = dayjs(shortcut.endDate)
        .endOf('day')
        .utc()
        .format('YYYY-MM-DD');
      onShortcutChange(shortcutLabel, startDate, endDate);
    }
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <Typography variant="body2" marginBottom={1} fontWeight="bold">
        {label}
      </Typography>
      <FormControl fullWidth size="small">
        <InputLabel id={`shortcut-${dateType}-label`}>Atajo</InputLabel>
        <Select
          labelId={`shortcut-${dateType}-label`}
          value={selectedShortcut || 'none'}
          onChange={(e) => handleChange(e.target.value)}
          label="Atajo"
        >
          <MenuItem value="none">Sin atajo</MenuItem>
          {shortcuts.map((sc) => (
            <MenuItem key={sc.label} value={sc.label}>
              {sc.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default DateShortcutSelector;
